<template lang="pug">
.cobrowse-configuration(v-if="cobrowseConfig")
  .configuration
    aiq-row.padding-5
      aiq-col(:span="8")
        label {{ $t('settings_tab.channels_tab.webchat_configuration.cobrowse_config.config.trusted_origins') }}
      aiq-col(:span="16")
        aiq-keyword-input(:list="cobrowseConfig.trustedOrigins"
                          @createItem="addItem('trustedOrigins', $event)"
                          @deleteItem="deleteItem('trustedOrigins', $event)"
                          :deletable="true")

    aiq-row.padding-5
      aiq-col(:span="8")
        label {{ $t('settings_tab.channels_tab.webchat_configuration.cobrowse_config.config.capabilities') }}
      aiq-col(:span="16")
        aiq-select(v-model="cobrowseConfig.capabilities"
                   size="small"
                   multiple
                   name="methods"
                   :reserve-keyword="false"
                   @change="$emit('update', cobrowseConfig)")
          aiq-option(v-for="m in capabilities"
                     :key="m"
                     :label="m"
                     :value="m")
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';

export default {
  name: 'cobrowse-configuration',
  props: {
    cobrowseConfig: {
      type: Object,
      default: null,
    },
  },
  emits: ['update'],
  computed: {
    capabilities() {
      return [
        'cursor',
        'disappearing_ink',
        'drawing',
        'full_device',
        'keypress',
        'laser',
        'pointer',
        'scroll',
        'select',
      ];
    },
  },
  methods: {
    addItem(name, item) {
      const newConfig = cloneDeep(this.cobrowseConfig);
      newConfig[name].push(item);
      this.$emit('update', newConfig);
    },
    deleteItem(name, item) {
      const newConfig = cloneDeep(this.cobrowseConfig);
      newConfig[name] = newConfig[name].filter(i => i !== item);
      this.$emit('update', newConfig);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./../../../../../styles/aiq-variables.scss";
@import "./../../../../../styles/aiq-mixins.scss";

.padding-5 {
  padding: 5px;
}
</style>
